import { render, staticRenderFns } from "./bidding-add-or-update.vue?vue&type=template&id=f177e2c2&scoped=true"
import script from "./bidding-add-or-update.vue?vue&type=script&lang=js"
export * from "./bidding-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./bidding-add-or-update.vue?vue&type=style&index=0&id=f177e2c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f177e2c2",
  null
  
)

export default component.exports